import type { TrackingEvent } from '../types';

/**
 * Events that exist only to report a Meta conversion.
 *
 * Each one describes an action that a differently named event already reports
 * to our own analytics, and is logged separately so the browser pixel and the
 * server-side Conversions API copy can be paired by Meta event name.
 * `HDESubmission` covers the same registration as `HdeSuccessRegister`.
 *
 * Two trackers act on them: `facebookTracker` sends the browser copy, and
 * `archiproTrackerV2` carries the deduplication id through Firehose so the
 * server copy can be paired with it. The trackers that report our own analytics
 * check this list and skip them, because reporting both names would count one
 * action twice.
 */
const META_ONLY_EVENTS = new Set<TrackingEvent>(['HDESubmission']);

/**
 * Whether this event exists only to report a Meta conversion.
 */
export function isMetaOnlyEvent(event: TrackingEvent): boolean {
    return META_ONLY_EVENTS.has(event);
}
